import React from "react";
import { Button } from "@mui/material";

const CustomButton = ({
  onClick,
  children,
  variant = "contained",
  disabled = false,
  color= "white.main",
  bgcolor = "#AD2A1C", //Reflex Blue
  hoverColor = "#891515", //75% Tint(#001489), Reflex Blue
  hoverTextColor = "white.main",
  size = "medium", // small | medium | large
  startIcon = null,
  endIcon = null,
  sx={},
  font = "tohoma, sans-serrif",
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      fontFamily={font}
      {...rest}
      sx={{
        bgcolor: bgcolor,
        color: color,
        textTransform: "none",
        fontWeight: "bold",
        "&:hover": {
          bgcolor: hoverColor,
          color: hoverTextColor,
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;